export default function BrandSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-2/5">
            <span className="inline-block px-3 py-1 text-xs font-medium text-foreground-500 border border-foreground-300 rounded-full mb-6">
              关于我们
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
              全网最全
            </h2>
            <h2 className="text-3xl md:text-4xl font-heading text-foreground-400 mb-8">
              吃瓜平台
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-8 max-w-md">
              51黑料网成立于2022年，致力于为吃瓜群众提供最新、最全、最真实的黑料爆料内容。我们7x24小时全天候追踪娱乐圈动态，重大爆料事件15分钟内上线。无论是明星塌房、网红翻车还是博主反差，51黑料网都在第一时间为你呈现。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-1 text-sm font-semibold text-foreground-950 border-b-2 border-accent-500 pb-1 hover:text-accent-600 transition-colors"
            >
              了解更多关于我们 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:w-3/5">
            <div className="flex items-start justify-end gap-16 mb-10">
              <div className="text-right">
                <p className="text-4xl md:text-5xl font-heading font-bold text-foreground-950">5000万<span className="text-accent-500">+</span></p>
                <p className="text-sm text-foreground-500 mt-2">月活跃用户</p>
              </div>
              <div className="text-right">
                <p className="text-4xl md:text-5xl font-heading font-bold text-foreground-950">120万<span className="text-accent-500">+</span></p>
                <p className="text-sm text-foreground-500 mt-2">累计爆料</p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-2xl overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20journalists%20working%20at%20computers%2C%20multiple%20monitors%20displaying%20news%20feeds%2C%20warm%20office%20lighting%2C%20professional%20media%20environment%2C%20clean%20modern%20workspace%2C%20editorial%20office%20photography%20style%2C%20neutral%20warm%20tones&width=480&height=480&seq=brand-img-01&orientation=squarish"
                  alt="51黑料网办公环境"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="w-52 h-64 md:w-64 md:h-80 rounded-2xl overflow-hidden bg-background-200 flex-shrink-0 -mt-6">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20broadcast%20studio%20with%20modern%20equipment%2C%20warm%20cinematic%20lighting%2C%20professional%20media%20production%20setup%2C%20dark%20sophisticated%20interior%2C%20high%20end%20recording%20studio%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20photography%20quality&width=640&height=800&seq=brand-img-02&orientation=portrait"
                  alt="51黑料网工作室"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}